module.exports = "/_next/static/images/4a5c38d29d7fefb160e2740e7bf7628c-features-lg.png.webp";